import React, { useState,useRef } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import {toast} from 'react-toastify';
import * as Yup from 'yup';
import api from '../../service/index';
import  Imagem  from '../../asset/LogoPF.png' ;
import './senha.css';

export default function SenhaApp(){

const [senha, setSenha] = useState('');
const [pass, setPass]= useState('');
const [resp, setResp] = useState('');

const validationSchema = Yup.object().shape({
    pass: Yup.string().required('Confirme sua senha'),
  senha: Yup.string()
      .min(6, 'A senha deve ter no minimo 6 caracters').max(10,"A senha deve ter no máximo 10 caracters"),
  confirmSenha: Yup.string()
      .required('Confirme sua senha')
      .oneOf([Yup.ref('senha')], 'A senha deve ser a mesma')    
});

const formOptions = { resolver: yupResolver(validationSchema) };
  const { register, handleSubmit, reset, formState } = useForm(formOptions);
  const { errors } = formState;

  async function onSubmit(data1) {
    ///alert(data1.senha);
    var dadoCodificado = window.btoa(data1.senha); // codifica a string
    // //var dadoDecodificado = window.atob(senha);
   /// console.log(dadoCodificado)

   var pass1 = data1.pass

   alert(data1.pass)

    try{
      const response = await api.post(`api/passreset/${pass1}/${dadoCodificado}`);
      console.log(response.data)
      setResp(response.data)
     // console.log(JSON.stringify(response.data.outBinds))
      toast.info(JSON.stringify(response.data.outBinds))
      setSenha("")
    }catch{
    }
}
    return(
      <div className='Conteiner'>
        <img src={Imagem} alt="LOGO" />
      <h5 className="card-header">Trocar senha</h5>
      <div className="card-body">
          <form onSubmit={handleSubmit(onSubmit)}>
              <div className="form-row">
              <div className="form-group col">
                      <label>Código</label>
                      <input name="pass" type="text" {...register('pass')} className={`form-control ${errors.pass ? 'is-invalid' : ''}`} />
                      <div className="invalid-feedback">{errors.pass?.message}</div>
                  </div>
                  <div className="form-group col">
                      <label>Senha</label>
                      <input name="senha" type="password" {...register('senha')} className={`form-control ${errors.senha ? 'is-invalid' : ''}`} />
                      <div className="invalid-feedback">{errors.senha?.message}</div>
                  </div>
                  <div className="form-group col">
                      <label>Confirmar  senha</label>
                      <input name="confirmSenha" type="password" {...register('confirmSenha')} className={`form-control ${errors.confirmSenha ? 'is-invalid' : ''}`} />
                      <div className="invalid-feedback">{errors.confirmSenha?.message}</div>
                  </div>
              </div>
              <div className="form-group">
                  <button type="submit" className="btn btn-primary mr-1">Confirmar</button>
              </div>
          </form>
      </div>
  </div>
    )
}

